module.exports = __webpack_public_path__ + "static/10-70286c4dff721a4261a5e128a52a507b.jpg";